module.exports = __webpack_public_path__ + "img/question-error-404.2fd273f1.svg";